const store = {
    namespaced: true,
    state: {
        pagination: {
            current_page: null,
            total_pages: null,
        },
        filter: {
            is_advanced_mode: false,
            shortcut_keys: ["name", "code", "phone", "note"],
            current_shortcut_key: "name",
            init_columns: {
                page: 1,
                name: null,
                code: null,
                phone: null,
                note: null,
            },
            columns: {}
        },
        stations: []
    },
    getters: {
        // filter 平面化 輸出一層object
        filter_to_query(state, getters, rootState, rootGetters) {
            let columns = _.cloneDeep(state.filter.columns)
            if (columns.page) delete columns.page
            return object_delete_null(columns)
        },
        filter_to_api_query(state, getters, rootState, rootGetters) {
            return (payload) => {
                let columns = _.cloneDeep(state.filter.columns)
                return object_to_query(columns)
            }
        },
    },
    actions: {
        fetch_stations(context, payload) {
            let url = new RestUrl(context.rootState.provider.routes.api_v1_provider_stations).parse(
                {},
                ""
            )
            let api_query = context.getters.filter_to_api_query()
            if (api_query) url += `?${api_query}`

            console.log(url);
            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        context.commit('set_stations', response.data.stations)
                        context.commit('set_pagination', response.data.pagination)
                    } else if (response.data.status == 'failure') {
                        return Promise.reject('fetch_stations_failure')
                    }
                })
                .catch(error => {
                    console.log(error);
                    return Promise.reject(
                        ResponseError(error)
                    )
                })
        },
        // query 轉成 filter格式 並 merge 到 filter
        handle_query_to_filter(context, payload = {}) {
            if (payload.query) {
                let query = {..._.cloneDeep(context.state.filter.init_columns), ...payload.query}
                context.state.filter.columns = {...context.state.filter.columns, ...query}
            }
        },
        // only run in init()
        handle_quick_filter_key(context, payload = {}) {
            let columns = object_delete_null(
                _.cloneDeep(context.state.filter.columns)
            )

            if (columns.page) delete columns.page

            let shortcut_key_occurrence_number = {
                number: 0,
                number_last_key: "",
            }

            context.state.filter.shortcut_keys.forEach((key) => {
                if(columns[key]) {
                    shortcut_key_occurrence_number.number += 1
                    shortcut_key_occurrence_number.number_last_key = key
                }
            })

            if (shortcut_key_occurrence_number.number == 1) {
                context.state.filter.current_shortcut_key =
                    shortcut_key_occurrence_number.number_last_key
            }

            if (
                (
                    shortcut_key_occurrence_number.number == 0 &&
                    Object.keys(columns).length >= 1
                ) || (
                    shortcut_key_occurrence_number.number >= 2
                )
            ) {
                context.state.filter.is_advanced_mode = true
            }
        },
    },
    mutations: {
        set_stations(state, payload) {
            state.stations = payload
        },
        set_pagination(state, payload) {
            state.pagination = payload
        },
        init_filter_columns(state) {
            state.filter.columns = _.cloneDeep(state.filter.init_columns)
        },
    }
}

export default store
